import { useEffect } from 'react';

/**
 * Hook para actualizar dinámicamente el favicon del sitio.
 * @param faviconUrl - URL del favicon a establecer. Si es null/undefined, no hace nada.
 */
export const useDynamicFavicon = (faviconUrl: string | null | undefined) => {
  useEffect(() => {
    if (!faviconUrl) return;

    // Buscar el link existente o crear uno nuevo
    let link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");

    if (!link) {
      link = document.createElement('link');
      document.head.appendChild(link);
    }

    // Configurar el favicon
    link.type = 'image/x-icon';
    link.rel = 'icon';
    link.href = faviconUrl;
  }, [faviconUrl]);
};

export default useDynamicFavicon;
